import api from "../../service";
import middleware from "../../middleware";

class DepartmentService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/departments`;
	}

    async getAll() {
        const { data } = await api.get(`${this.url}`)
        return data
    }

    async get(id) {
        const { data } = await api.get(`${this.url}/${id}`)
        return data
    }

	async setFavorite(id) {
        const { data } = await api.get(`${this.url}/setFavorite/${id}`)
        return data
    }
}

export default DepartmentService
